import gql from 'graphql-tag'
import {Errors} from "./Common"

export const CreateContactComment = gql`
mutation($input: CreateContactCommentInput!) {
  createContactComment(input: $input) {
    contactComments {
      id
      contactId
      userId
      adminUserId
      comment
      image
      imageUrl
      elapsedTime
      isPdf
      user {
        nickname
        name
      }
      adminUser {
        adminShop {
          name
          logoImageSet {
            smSqImage
          }
        }
      }
      contactId
    }
    errors {
      message
    }
  }
}
`

export const GET_CONTACT_COMMENT_PDF = gql`
  query ($contactId: ID!, $contactCommentId: ID!) {
    downloadContactCommentPdf(contactId: $contactId, contactCommentId: $contactCommentId) {
      pdfUrl
    }
  }
`;

